import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import theme from "styles/theme";
import Eye from "components/icons/eye";
import FlatButton from "material-ui/FlatButton";
import ViewAsDropdown from "./view-as-dropdown";
import Globalize from "globalize";
import { merge, $ } from "glamor";
import { DATATEST } from "constants/integration";
import _ from "lodash";

class ViewAs extends PureComponent {
    static propTypes = {
        viewAs: PropTypes.object,
        viewAsGuest: PropTypes.bool,
        onToggleViewAsGuest: PropTypes.func,
        me: PropTypes.object.isRequired,
        onSetViewAs: PropTypes.func.isRequired,
        scope: PropTypes.object.isRequired,
        showSearch: PropTypes.bool,
        hideMsrp: PropTypes.bool.isRequired,
        onToggleHideMsrp: PropTypes.func.isRequired,
        hideWholesale: PropTypes.bool.isRequired,
        onToggleHideWholesale: PropTypes.func.isRequired,
    };

    styles = {
        viewAsButton: {
            display: "block",
            minWidth: "44px",
            margin: "10px 0 0 0",
        },
        buttonLabel: {
            color: theme.palette.primary1Color,
        },
        viewAsIcon: {
            fill: theme.palette.grey,
        },
        viewAsIconSelected: {
            fill: theme.palette.darkGrey,
        },
        component: merge(
            {
                transition: "height 0.3s ease",
                position: "relative",
                height: `${theme.appBar.height}px`,
            },
            $(" .companyName", {
                display: "block",
                lineHeight: "44px",
            }),
        ),
    };

    constructor(props) {
        super(props);

        this.state = {
            open: false,
        };

        this.handleToggleMenu = this.handleToggleMenu.bind(this);
        this.handleClickAway = this.handleClickAway.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { me, onSetViewAs, scope, router } = this.props;
        // TODO:- Will implement for all user type later
        const isGalleryPage = router.location.pathname.includes("gallery");
        const isItemPage = router.location.pathname.includes("item");
        // router replace should only occur when brand-switching is not taking place
        if (router.location.pathname.includes(scope?.brand?._id)) {
            if (me.account_type === "buyer" && scope.brand && scope.companies.length > 1) {
                let viewAs = scope.company;
                if (isGalleryPage || isItemPage) {
                    const viewAsCompanyId = router.location.query.viewAs;
                    viewAs = (viewAsCompanyId && _.find(scope.companies, { _id: viewAsCompanyId })) || viewAs;
                    router.replace({
                        pathname: router.location.pathname,
                        query: { ...router.location.query, viewAs: viewAs._id },
                    });
                }
                onSetViewAs(viewAs);
            }
            if (me.account_type !== "buyer" || !isGalleryPage || !isItemPage) {
                router.replace({ pathname: router.location.pathname, query: _.omit(router.location.query, "viewAs") });
            }
        }
        window.addEventListener("touchstart", this.handleClickAway);
        window.addEventListener("click", this.handleClickAway);
    }

    componentWillUnmount() {
        window.removeEventListener("touchstart", this.handleClickAway);
        window.removeEventListener("click", this.handleClickAway);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (
            nextProps.viewAsGuest &&
            nextProps.scope.brand &&
            nextProps.scope.brand._id &&
            !nextProps.scope.brand.hasPreference("allow_guest_buyers")
        ) {
            nextProps.onToggleViewAsGuest();
        }
        if (this.props.viewAs !== nextProps.viewAs || this.props.viewAsGuest !== nextProps.viewAsGuest) {
            this.setState({ open: false });
        }
    }

    handleClickAway(e) {
        const { open } = this.state;
        if (e.defaultPrevented || !open) {
            return;
        }

        const el = this._main;
        if (
            (e.target !== el && e.target === window) ||
            (document.documentElement.contains(e.target) && !this.isDescendant(el, e.target))
        ) {
            this.setState({ open: false });
        }
    }

    isDescendant(parent, child) {
        let node = child.parentNode;

        while (node !== null) {
            if (node === parent) {
                return true;
            }
            node = node.parentNode;
        }

        return false;
    }

    handleToggleMenu() {
        this.setState({ open: !this.state.open });
    }

    handleSetViewAs = (company) => {
        const { me, router } = this.props;
        if (
            me.account_type === "buyer" &&
            (router.location.pathname.includes("gallery") || router.location.pathname.includes("item"))
        ) {
            router.replace({
                pathname: router.location.pathname,
                query: { ...router.location.query, viewAs: company._id },
            });
        }
        this.props.onSetViewAs(company);
    };

    render() {
        const {
            me,
            viewAsGuest,
            viewAs,
            onToggleViewAsGuest,
            scope,
            showSearch,
            hideMsrp,
            hideWholesale,
            onToggleHideMsrp,
            onToggleHideWholesale,
        } = this.props;
        const { open } = this.state;
        const styles = this.styles;
        const isBuyerWithSingleCompany = me.account_type === "buyer" && scope.brand && scope.companies.length <= 1;
        /*
         * If user is buyer and has only one company but has permission `can_hide_pricing`
         * we should show him `View As` but only toggles connected with hiding pricings.
         */
        if (!scope.brand || (isBuyerWithSingleCompany && !me.hasPermission("can_hide_pricing"))) {
            return null;
        }

        const showViewAsGuest = scope.brand.hasPreference("allow_guest_buyers");

        let label = undefined;
        if (viewAs) {
            label = viewAs.__name;
        } else if (viewAsGuest && showViewAsGuest) {
            label = Globalize.formatMessage("Guest Buyer");
        }
        return (
            <div ref={(ref) => (this._main = ref)} {...styles.component}>
                <FlatButton
                    onClick={this.handleToggleMenu}
                    label={label}
                    style={this.styles.viewAsButton}
                    labelStyle={styles.buttonLabel}
                    icon={
                        <Eye
                            style={viewAs || viewAsGuest ? this.styles.viewAsIconSelected : this.styles.viewAsIcon}
                            data-test={DATATEST.SITE_HEADER.VIEW_AS_BTN}
                        />
                    }
                />
                <ViewAsDropdown
                    me={me}
                    scope={scope}
                    open={open}
                    viewAs={viewAs}
                    viewAsGuest={viewAsGuest}
                    showViewAsGuest={showViewAsGuest}
                    onSetViewAs={this.handleSetViewAs}
                    onToggleViewAsGuest={onToggleViewAsGuest}
                    showSearch={showSearch}
                    hideMsrp={hideMsrp}
                    onToggleHideMsrp={onToggleHideMsrp}
                    hideWholesale={hideWholesale}
                    onToggleHideWholesale={onToggleHideWholesale}
                    isBuyerWithSingleCompany={isBuyerWithSingleCompany}
                />
            </div>
        );
    }
}

export default ViewAs;
